import React from 'react'
import LatinoTemplateDefault from 'src/components/template/la/'
import { laDiscountPriceMonthly } from 'src/constants/planData/latinoPlanData'
import { videos } from 'src/constants/videos'
export default (props) => {
  return (
    <LatinoTemplateDefault
      location={props.location}
      lang="en"
      market="latino"
      video={videos.espn.videoUrl}
      annotations={videos.espn.annotations}
      title="Stream American Sports"
      subtitle={
        <>
          Access now for only <span className="green-underline">${laDiscountPriceMonthly}</span> the
          first month
        </>
      }
      networkSet="entertainmentLatino"
      customNetworks={['espndeportes']}
      noteLink="/la/american-es/"
    />
  )
}
